import moment from "moment";
import { GetAllChapterApi } from "src/api/chapterSetting";
import {
  getChapter,
  insertmember,
  getState,
  getCity,
  GetAllMemberApi,
  getPollSelect,
  getAllGallery,
  getAllPoll,
  getAllEventAnnou,
  getAllCity,
  getAllState,
  getAllCountry,
  getAllLandmark,
  getAllChapter,
  getAllBusiness,
  getAllV2v,
  getAllReference,
  GetStateById,
  getattendance,
  getMemberAttendanceByChepter,
  getMemberAttendanceById,
  getAllGreeting,
  getChapterByCity,
  getCityAmbassadorById,
  GetStaffByPid,
  getAllocateListById,
  getStaffById,
  getTaskList,
  getLeadList,
  getTaskByTid,
  getLeadHistory,
  getChapterByUser,
  getMeetingByUser,
  getAllCityAmbassador,
  getRenewalMemberData,
  getDashboardCounter,
  getDashboardPinCounter,
  getWalletHistoryById,
  getMemberFeeHistory,
  getFolderByCityId,
  getDocumentByFid,
  getAllvisitor,
  getAllTestimonial,
  getV2vByMemberReport,
  getBusinessByMemberReport,
  getReferenceByMemberReport,
  getVisitorByMemberReport,
  getAttendanceByMemberReport,
  getLvbCounterWeb,
  getcityambdetailbyid,
  findTopper,
  getPinBadge,
  getPinByMemberId,
  getMembersDetailedReport,
  getMembersSpecificDetailedReport,
  fetchBlockVisitorList,
  fetchLeadDetailsById,
  getSuggestionList,
  getMemberInductionList,
  thankYouNoteApprovalData,
  getNewLeadList,
  getPinAssignReport,
  getAllNotification,
  getMembershipFlowList,
  getMagazineList,
  getAllTrainingWebinar,
  getAchievementPinBadge,
  fetchBlockMemberList,
  getStockReportCitylist,
  getPendingStockOverview as getPendingStockOverviewApi,
  getPendingStockFilterOptions as getPendingStockFilterOptionsApi,
  getChapterListWithCoordinators as getChapterListWithCoordinatorsApi,
  getSystemLogModules,
  getSystemLogs,
  getCitySupportList as fetchCitySupportListApi,
  createCitySupportProfile as createCitySupportProfileApi,
  updateCitySupportProfile as updateCitySupportProfileApi,
  deleteCitySupportProfile as deleteCitySupportProfileApi,
  updateCitySupportProfileStatus as toggleCitySupportProfileStatusApi,
  getCityEdDetails as getCityEdDetailsApi,
  saveCityEdDetails as saveCityEdDetailsApi
} from "src/api/commonapi";
import { getLvbDocument } from "../api/commonapi";

export async function fetchStateList() {
  try {
    const resp = await getState();
    return resp;
  } catch {
    return null;
  }
}

export async function fetchCityList(cid) {
  try {
    const resp = await getCity(cid);
    return resp;
  } catch {
    return null;
  }
}
export async function GetAllChapter(cid) {
  try {
    const resp = await GetAllChapterApi(cid);
    return resp;
  } catch {
    return null;
  }
}

export async function GetAllMember(city_id, u_type) {
  try {
    const resp = await GetAllMemberApi(city_id, u_type);
    return resp.data;
  } catch {
    return null;
  }
}

export async function fetchGalleryList() {
  try {
    const resp = await getAllGallery();
    if (resp.status == 1) return resp.data;
    else return null;
  } catch {
    return null;
  }
}

export async function fetchPollList(city_id, u_type, filters = {}) {
  try {
    const resp = await getAllPoll(city_id, u_type, filters);
    if (resp.status == 1) return { data: resp.data, pagination: resp.pagination };
    else return { data: null, pagination: null };
  } catch {
    return { data: null, pagination: null };
  }
}

export async function PollSelect(e, userType, cityId) {
  try {
    const resp = await getPollSelect(e, userType, cityId);
    if (resp.status == 1) return resp.data;
    else return resp;
  } catch {
    return null;
  }
}

export async function fetchEventAnnouList(city_id, u_type) {
  try {
    const resp = await getAllEventAnnou(city_id, u_type);
    if (resp.status == 1) return resp.data;
    else return null;
  } catch {
    return null;
  }
}
export async function fetchGreetingList(city_id, u_type) {
  try {
    const resp = await getAllGreeting(city_id, u_type);
    if (resp.status == 1) return resp.data;
    else return null;
  } catch {
    return null;
  }
}

export async function fetchallcitylist() {
  try {
    const resp = await getAllCity();
    return resp.data;
  } catch {
    return null;
  }
}

export async function fetchallstatelist(cid) {
  try {
    const resp = await getAllState(cid);
    return resp;
  } catch {
    return null;
  }
}

export async function fetchallcountrylist(cid) {
  try {
    const resp = await getAllCountry(cid);
    return resp;
  } catch {
    return null;
  }
}

export async function fetchLandmarkList() {
  try {
    const resp = await getAllLandmark();
    if (resp.status == 1) return resp.data;
    else return null;
  } catch {
    return null;
  }
}

export async function fetchChaptList() {
  try {
    const resp = await getAllChapter();
    return resp;
  } catch {
    return null;
  }
}

export async function fetchBusinessList(ch_id, m_id) {
  try {
    const resp = await getAllBusiness(ch_id, m_id);
    if (resp.status == 1) return resp.data;
    else return null;
  } catch {
    return null;
  }
}

export async function fetchV2vList(ch_id, m_id) {
  try {
    const resp = await getAllV2v(ch_id, m_id);
    if (resp.status == 1) return resp.data;
    else return null;
  } catch {
    return null;
  }
}

export async function fetchVisitorList(ch_id, m_id) {
  try {
    const resp = await getAllvisitor(ch_id, m_id);
    if (resp.status == 1) return resp.data;
    else return null;
  } catch {
    return null;
  }
}

export async function fetchTestimonialList(m_id) {
  try {
    const resp = await getAllTestimonial(m_id);
    if (resp.status == 1) return resp.data;
    else return null;
  } catch {
    return null;
  }
}

export async function fetchReferenceList(ch_id, m_id) {
  try {
    const resp = await getAllReference(ch_id, m_id);
    if (resp.status == 1) return resp.data;
    else return null;
  } catch {
    return null;
  }
}

export async function fetchStateById(id) {
  try {
    const resp = await GetStateById(id);
    if (resp.status == 1) return resp;
  } catch {
    return null;
  }
}

export async function fetchAttendance(id) {
  try {
    const resp = await getattendance(id);
    if (resp.status == 1) return resp;
  } catch {
    return null;
  }
}

export async function fetchMemberAttendanceByChepter(data) {
  try {
    const resp = await getMemberAttendanceByChepter(data);
    if (resp.status == 1) return resp.data;
  } catch {
    return null;
  }
}

export async function fetchMemberAttendanceById(data) {
  try {
    const resp = await getMemberAttendanceById(data);
    if (resp.status == 1) return resp;
  } catch {
    return null;
  }
}

export async function fetchchapterlistbycity(data) {
  try {
    const resp = await getChapterByCity(data);
    if (resp.status == 1) return resp.data;
  } catch {
    return null;
  }
}

export async function fetchcityambassadorbyid(data) {
  try {
    const resp = await getCityAmbassadorById(data);
    if (resp.status == 1) return resp.data;
  } catch {
    return null;
  }
}

export async function fetchNewLeadList(data) {
  try {
    const resp = await getNewLeadList(data);
    if (resp.status == 1) return resp?.data;
  } catch {
    return null;
  }
}

export async function fetchstaffbypid(u_id, u_type) {
  try {
    const resp = await GetStaffByPid(u_id, u_type);
    if (resp.status == 1) return resp.data;
  } catch {
    return null;
  }
}

export async function fetchallocatelistbyid(u_id, u_type) {
  try {
    const resp = await getAllocateListById(u_id, u_type);
    if (resp.status == 1) return resp.data;
  } catch {
    return null;
  }
}

export async function fetchstaffListbypid(u_id, u_type) {
  try {
    const resp = await getStaffById(u_id, u_type);
    if (resp.status == 1) return resp.data;
  } catch {
    return null;
  }
}

export async function fetchtasklistbyid(u_id, u_type) {
  try {
    const resp = await getTaskList(u_id, u_type);
    if (resp.status == 1) return resp?.data;
  } catch {
    return null;
  }
}

export async function fetchleadlistbyid(u_id, u_type) {
  try {
    const resp = await getLeadList(u_id, u_type);
    if (resp.status == 1) return resp?.data;
  } catch {
    return null;
  }
}

export async function fetchtaskbytid(t_id) {
  try {
    const resp = await getTaskByTid(t_id);
    if (resp.status == 1) return resp?.data;
  } catch {
    return null;
  }
}

export async function featchleadhistory(l_id) {
  try {
    const resp = await getLeadHistory(l_id);
    if (resp.status == 1) return resp?.data;
  } catch {
    return null;
  }
}

export async function fetchchapterbyuser(city_id, u_type) {
  try {
    const resp = await getChapterByUser(city_id, u_type);
    if (resp.status == 1) return resp?.data;
  } catch {
    return null;
  }
}

export async function fetchmeetingbyuser(city_id, u_type) {
  try {
    const resp = await getMeetingByUser(city_id, u_type);
    if (resp.status == 1) return resp?.data;
  } catch {
    return null;
  }
}

export async function fetchallcityamabassador(data) {
  try {
    const resp = await getAllCityAmbassador(data);
    if (resp.status == 1) return resp;
  } catch {
    return null;
  }
}

export async function fetchrenewalmemberdata(l_id) {
  try {
    const resp = await getRenewalMemberData(l_id);
    if (resp.status == 1) return resp?.data;
  } catch {
    return null;
  }
}

export async function fetchdashboardcounter(u_id, u_type, city_id) {
  try {
    const resp = await getDashboardCounter(u_id, u_type, city_id);
    if (resp.status == 1) return resp?.data;
  } catch {
    return null;
  }
}

export async function fetchdashboardpincounter(city_id) {
  try {
    const resp = await getDashboardPinCounter(city_id);
    if (resp.status == 1) return resp?.data;
    return [];
  } catch {
    return [];
  }
}

export async function fetchwallethistorybyid(c_a_id) {
  try {
    const resp = await getWalletHistoryById(c_a_id);
    if (resp.status == 1) return resp?.data;
  } catch {
    return null;
  }
}

export async function fetchmemberfeehistory(m_id) {
  try {
    const resp = await getMemberFeeHistory(m_id);
    if (resp.status == 1) return resp?.data;
  } catch {
    return null;
  }
}

export async function fetchlvbdocument(city_id) {
  try {
    const resp = await getLvbDocument(city_id);
    if (resp.status == 1) return resp?.data;
  } catch {
    return null;
  }
}

export async function fetchFolderByCityId(city_id) {
  try {
    const resp = await getFolderByCityId(city_id);
    if (resp.status == 1) return resp?.data;
  } catch {
    return null;
  }
}

export async function fetchDocumentByFid(f_id) {
  try {
    const resp = await getDocumentByFid(f_id);
    if (resp.status == 1) return resp?.data;
  } catch {
    return null;
  }
}

export async function fetchV2vListByMember(ch_id, m_id) {
  try {
    const resp = await getV2vByMemberReport(ch_id, m_id);
    if (resp.status == 1) return resp.data;
    else return null;
  } catch {
    return null;
  }
}

export async function fetchBusinessListByMember(ch_id, m_id) {
  try {
    const resp = await getBusinessByMemberReport(ch_id, m_id);
    if (resp.status == 1) return resp.data;
    else return null;
  } catch {
    return null;
  }
}

export async function fetchReferenceByMember(ch_id, m_id) {
  try {
    const resp = await getReferenceByMemberReport(ch_id, m_id);
    if (resp.status == 1) return resp.data;
    else return null;
  } catch {
    return null;
  }
}

export async function fetchVisitorByMember(ch_id, m_id) {
  try {
    const resp = await getVisitorByMemberReport(ch_id, m_id);
    if (resp.status == 1) return resp.data;
    else return null;
  } catch {
    return null;
  }
}

export async function fetchAttendanceByMember(m_id) {
  try {
    const resp = await getAttendanceByMemberReport(m_id);
    if (resp.status == 1) return resp.data;
    else return null;
  } catch {
    return null;
  }
}

export async function fetchLvbCounterWeb(id) {
  try {
    const resp = await getLvbCounterWeb(id);
    if (resp.status == 1) return resp.data;
    else return null;
  } catch {
    return null;
  }
}

export function strToAmountNumberConvert(value) {
  var val = Math.abs(value);
  if (val >= 10000000) {
    val = (val / 10000000).toFixed(2) + " Cr" + " (" + value.toLocaleString() + ")";
  } else if (val >= 100000) {
    val = (val / 100000).toFixed(2) + " Lac" + " (" + value.toLocaleString() + ")";
  } else if (val >= 1000) {
    val = (val / 1000).toFixed(2) + " K" + " (" + value.toLocaleString() + ")";
  } else {
    val = val.toLocaleString();
  }
  return val;
}

export async function fetchCityAmbDetailById(id) {
  try {
    const resp = await getcityambdetailbyid(id);
    if (resp.status == 1) return resp.data;
    else return null;
  } catch (error) {
    return null;
  }
}

export async function fetchPinList(type) {
  try {
    const resp = await getPinBadge(type);
    if (resp.status == 1) return resp.data;
    else return null;
  } catch (error) {
    return null;
  }
}

export async function getPinBadgeByMemberId(id) {
  try {
    const resp = await getPinByMemberId(id);
    if (resp.status == 1) return resp.data;
    else return null;
  } catch (error) {
    return null;
  }
}

export async function getMembersDetailedReportHandler(data) {
  try {
    const resp = await getMembersDetailedReport(data);
    if (resp.status == 1) return resp.data;
    else return null;
  } catch (error) {
    return null;
  }
}

export async function getMembersSpecificDetailedReportHandler(data) {
  try {
    const resp = await getMembersSpecificDetailedReport(data);
    if (resp.status == 1) return resp.data;
    else return null;
  } catch (error) {
    return null;
  }
}

// export async function FetchfindTopper(data) {
//   try {
//     const resp = await findTopper(data);
//     if (resp.status == 1) return resp.data;
//     else return null;
//   } catch {
//     return null;
//   }
// }

export async function getBlockVisitorCommonFunction(city_id) {
  try {
    const resp = await fetchBlockVisitorList(city_id);
    if (resp.status == 1) return resp.data;
    else return null;
  } catch (error) {
    return null;
  }
}

export async function getLeadDetailsUsingId(id) {
  try {
    const resp = await fetchLeadDetailsById(id);
    if (resp.status == 1) return resp.data;
    else return null;
  } catch (error) {
    return null;
  }
}

export async function getSuggestionListByCity(data) {
  try {
    const resp = await getSuggestionList(data);
    if (resp.status == 1) return resp;
    else return null;
  } catch (error) {
    return null;
  }
}

export async function fetchMemberInductionList(data) {
  try {
    const resp = await getMemberInductionList(data);
    if (resp.status == 1) return resp.data;
    else return null;
  } catch (error) {
    return null;
  }
}

export async function fetchThankYouNoteWaitingsForApprovalList(city_id) {
  try {
    const resp = await thankYouNoteApprovalData(city_id);
    if (resp.status == 1) return resp.data;
    else return null;
  } catch (error) {
    return null;
  }
}

export async function getPinAssignReportHandler(data) {
  try {
    const resp = await getPinAssignReport(data);
    if (resp.status == 1) return resp.data;
    else return null;
  } catch (error) {
    return null;
  }
}

export async function fetchMembershipFlowList() {
  try {
    const resp = await getMembershipFlowList();
    if (resp.status == 1) return resp.data;
    else return null;
  } catch {
    return null;
  }
}

export async function fetchMagazineList(city_id, u_type) {
  try {
    const resp = await getMagazineList(city_id, u_type);
    if (resp.status == 1) return resp.data;
    else return null;
  } catch {
    return null;
  }
}

export async function fetchNotificationList(city_id, u_type, filters = {}) {
  try {
    const resp = await getAllNotification(city_id, u_type, filters);
    if (resp.status == 1) return { data: resp.data, pagination: resp.pagination };
    else return { data: null, pagination: null };
  } catch {
    return { data: null, pagination: null };
  }
}

export async function fetchTrainingWebinarList(city_id, u_type) {
  try {
    const resp = await getAllTrainingWebinar(city_id, u_type);
    if (resp.status == 1) return resp.data;
    else return null;
  } catch {
    return null;
  }
}

export async function fetchAchievementPinList() {
  try {
    const resp = await getAchievementPinBadge();
    if (resp.status == 1) return resp.data;
    else return null;
  } catch (error) {
    return null;
  }
}
// approvedThankyouNoteRequest

export async function getBlockMemberCommonFunction(data) {
  try {
    const resp = await fetchBlockMemberList(data);
    if (resp.status == 1) return resp.data;
    else return null;
  } catch (error) {
    return null;
  }
}

export async function fetchstockReportCitylist() {
  try {
    const resp = await getStockReportCitylist();
    return resp.data;
  } catch {
    return null;
  }
}

export async function fetchPendingStockOverview(data) {
  try {
    const resp = await getPendingStockOverviewApi(data);
    if (resp.status == 1) return resp;
    return resp;
  } catch {
    return null;
  }
}

export async function fetchPendingStockFilterOptions() {
  try {
    const resp = await getPendingStockFilterOptionsApi();
    if (resp.status == 1) return resp.data;
    return resp?.data || null;
  } catch {
    return null;
  }
}

export async function fetchChapterListWithCoordinators(data) {
  try {
    const resp = await getChapterListWithCoordinatorsApi(data);
    return resp;
  } catch {
    return null;
  }
}

export async function fetchSystemLogModules() {
  try {
    const resp = await getSystemLogModules();
    return resp;
  } catch {
    return null;
  }
}

export async function fetchSystemLogs(params) {
  try {
    const resp = await getSystemLogs(params);
    return resp;
  } catch {
    return null;
  }
}

export const handleDownload = async (path, url) => {
  try {
    const response = await fetch(path);
    const blob = await response.blob();

    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = url || "file";

    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(blobUrl);
  } catch (err) {
    console.error("Download failed", err);
  }
};

export async function fetchCitySupportList(city_id = 0) {
  try {
    const resp = await fetchCitySupportListApi({ city_id });
    return resp.data;
  } catch {
    return null;
  }
}

export async function createCitySupportProfile(data) {
  try {
    const resp = await createCitySupportProfileApi(data);
    return resp;
  } catch {
    return null;
  }
}

export async function updateCitySupportProfile(data) {
  try {
    const resp = await updateCitySupportProfileApi(data);
    return resp;
  } catch {
    return null;
  }
}

export async function deleteCitySupportProfile(data) {
  try {
    const resp = await deleteCitySupportProfileApi(data);
    return resp;
  } catch {
    return null;
  }
}

export async function toggleCitySupportProfileStatus(data) {
  try {
    const resp = await toggleCitySupportProfileStatusApi(data);
    return resp;
  } catch {
    return null;
  }
}

export async function fetchCityEdDetails(city_id) {
  try {
    const resp = await getCityEdDetailsApi({ city_id });
    return resp.data;
  } catch {
    return null;
  }
}

export async function saveCityEdDetails(data) {
  try {
    const resp = await saveCityEdDetailsApi(data);
    return resp;
  } catch {
    return null;
  }
}

export const formatExpiryExtension = (actualDate, expectedDate) => {
  const from = moment(expectedDate, "DD-MM-YYYY").startOf("day");
  const to = moment(actualDate, "DD-MM-YYYY").startOf("day");
  if (!from.isValid() || !to.isValid()) {
    return { tone: "neutral", text: "No Extension", days: 0 };
  }
  if (to.isSame(from)) {
    return { tone: "neutral", text: "No Extension", days: 0 };
  }
  const positive = to.isAfter(from);
  const a = positive ? from : to;
  const b = positive ? to : from;
  const years = b.diff(a, "years");
  const months = b.diff(a.clone().add(years, "years"), "months");
  const days = b.diff(a.clone().add(years, "years").add(months, "months"), "days");
  const parts = [];
  if (years) parts.push(`${years} year`);
  if (months) parts.push(`${months} month`);
  if (days) parts.push(`${days} days`);
  const amount = parts.join(" ") || "0 days";
  const totalDays = b.diff(a, "days");
  if (positive) {
    return { tone: "success", text: `+${amount} extended`, days: totalDays };
  }
  return { tone: "error", text: `-${amount} shortened`, days: -totalDays };
};

export const getDefaultExpiryDate = (baseDate, previousDueDate) => {
  if (previousDueDate) {
    return moment(previousDueDate, "DD-MM-YYYY").add(1, "year").format("DD-MM-YYYY");
  }
  if (baseDate) {
    return moment(baseDate, "DD-MM-YYYY").add(1, "year").format("DD-MM-YYYY");
  }
  return moment().add(1, "year").format("DD-MM-YYYY");
};
